import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import pkg from '../package.json';

i18n
  .use(LanguageDetector)
  .use(XHR)
  .init({
    debug: false,
    fallbackLng: 'en',
    supportedLngs: ['pl', 'en', 'uk', 'ru', 'es', 'de', 'cz'],
    load: 'languageOnly',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 60 * 24 * 365,
      cookieDomain: window.location.hostname,
      htmlTag: document.documentElement,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: pkg.version }
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'a']
    }
  }, (err) => {
    if (err) {
      console.error('i18n initialization error:', err);
    }
  });

export default i18n;
